<div class="main">
    <div *ngIf="showLoader" class="loader">
        <div class="load">
            <mat-spinner></mat-spinner>
        </div>
    </div>
    <div class="section">

        <div class="top_header">
            <div class="item">
                <div class="label">
                    {{'MWG'}}
                </div>

            </div>
        </div>
        <div class="filters_sec">
            <div class="left">
              <div class="filter">
                <div class="input">
                  <input type="text" class="inputField" placeholder="From" [(ngModel)]="fromDate" [min]="minDate"
                    (click)="fromDateInput3.open()" [matDatepicker]="fromDateInput3" />
                  <mat-datepicker #fromDateInput3 (closed)="getMwgDetails()">
                  </mat-datepicker>
                  <span class="material-icons dateIcon"> <img src="assets/calender-icon.svg" alt=""> </span>
                </div>
              </div>
              <div class="filter">
                <div class="input">
                  <input type="text" class="inputField" placeholder="To" [(ngModel)]="toDate" [min]="minDate"
                    (click)="toDateInput3.open()" [matDatepicker]="toDateInput3" />
                  <mat-datepicker #toDateInput3 (closed)="getMwgDetails()">
                  </mat-datepicker>
                  <span class="material-icons dateIcon"> <img src="assets/calender-icon.svg" alt=""> </span>
                </div>
              </div>
              <div class="item">
                <!-- <input type="text" class="inputSelect" placeholder="Status" [matAutocomplete]="statusSelect" [(ngModel)]="selectedStatus">
                <mat-autocomplete #statusSelect="matAutocomplete">
                    <mat-option *ngFor="let option of statuses" [value]="option" (click)="selectStatus(option)">
                        <span>{{option}}</span>
                    </mat-option>
                </mat-autocomplete> -->
                <mat-select class="inputSelectdropdown"  [(ngModel)]="selectedStatus" >
                  <mat-option *ngFor="let option of statuses" [value]="option" (click)="selectStatus(option)">
                    <span>{{option}}</span>
                </mat-option>
              </mat-select>
                <!-- <div *ngIf="selectedStatus" class="clear_selected" (click)="selectedStatus = ''; getMwgDetails();">
                  <mat-icon class="close_icon">highlight_off</mat-icon>
              </div> -->
            </div>
            <div class="item">
              <input type="text" class="inputSelect" placeholder="SIN" [(ngModel)]="selectedSIN">
              <div *ngIf="selectedSIN" class="clear_selected" (click)="selectedSIN = ''; getMwgDetails();">
                <mat-icon class="close_icon">highlight_off</mat-icon>
              </div>
            </div>
            <div class="item">
              <input type="text" class="inputSelect" placeholder="Vehicle"  [(ngModel)]="selectedVehicle">
              <div *ngIf="selectedVehicle" class="clear_selected" (click)="selectedVehicle = ''; getMwgDetails();">
              <mat-icon class="close_icon">highlight_off</mat-icon>
              </div>
            </div>
            <div class="item">
              <input type="text" class="inputSelect" placeholder="DO Number" [(ngModel)]="selectedDo">
              <div *ngIf="selectedDo" class="clear_selected" (click)="selectedDo = ''; getMwgDetails();">
                <mat-icon class="close_icon">highlight_off</mat-icon>
              </div>
            </div>
            <div class="newButton" style=" color: #fff; " *ngIf="selectedDo || selectedVehicle || selectedSIN " (click)=" getMwgDetails()">
              search
            </div>
            </div>
            <div style="cursor: pointer;margin-top: 8px;" (click)="getMwgDetails()">
              <img src="assets/refresh-icon.svg" alt="">
            </div>
      
          </div>

        <div class="body">
            <div class="table">
                <table mat-table [dataSource]="mwgDatasource">

                    <ng-container matColumnDef="sno">
                        <th mat-header-cell *matHeaderCellDef> {{'S.No'| translate}} </th>
                        <td mat-cell *matCellDef="let element; let i = index"> {{i+1}} </td>
                    </ng-container>
                    <ng-container matColumnDef="sin">
                        <th mat-header-cell *matHeaderCellDef> {{'SIN'| translate}} </th>
                        <td mat-cell *matCellDef="let element;"> {{element.shipment.SIN}} </td>
                    </ng-container>

                    <ng-container matColumnDef="pickup">
                        <th mat-header-cell *matHeaderCellDef> {{'Pickup & Delivery'| translate}} </th>
                        <td mat-cell *matCellDef="let element">
                            <ng-container *ngFor="let material of element.shipment.pickups" matColumnDef="column1">
                                <div class="parent" style="display:flex; width: 264px; ">
                                    <div class="ch" style="width: 10px; ">
                                        <img src="assets/pickup_icon.svg">
                                    </div>
                                    <div class="ch" style="width: 254px; ">
                                        {{ material.location.name || '-'}}
                                    </div>
                                </div>
                            </ng-container>

                            <ng-container *ngFor="let material of element.shipment.deliveries" matColumnDef="column1">
                                
                                <div class="parent" style="display:flex; width: 264px; ">
                                    <div class="ch" style="width: 10px; ">
                                        <img src="assets/drop_icon.svg">
                                    </div>
                                    <div class="ch" style="width: 254px; ">
                                        {{ material.location.name || '-'}}
                                    </div>
                                </div>
                            </ng-container>
                        </td>
                    </ng-container>


                    <ng-container matColumnDef="shipper">
                        <th mat-header-cell *matHeaderCellDef> {{'Shipper'| translate}} </th>
                        <td mat-cell *matCellDef="let element"> {{element.name}}<br />{{element.shipper.parent_name}}
                        </td>
                    </ng-container>


                    <ng-container matColumnDef="material">

                        <th mat-header-cell *matHeaderCellDef> {{'Material'| translate}} </th>
                        <td mat-cell *matCellDef="let element">
                            <ng-container *ngFor="let material of element.driver.materials">
                                {{ material.name || '-'}}
                            </ng-container>
                        </td>
                    </ng-container>


                    <ng-container matColumnDef="vehicle">
                        <th mat-header-cell *matHeaderCellDef> {{'Vehicle No.'| translate}} </th>
                        <td mat-cell *matCellDef="let element"> {{element.driver.vehicle_no}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="doNumber">
                        <th mat-header-cell *matHeaderCellDef> {{'DO No.'| translate }} </th>
                        <td mat-cell *matCellDef="let element">
                            <ng-container *ngFor="let material of element.shipment.do_numbers">
                                {{ material || '-' }}
                            </ng-container>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="loadedWeight">
                        <th mat-header-cell *matHeaderCellDef> {{'Loaded Weight (MT).'| translate}} </th>
                        <td mat-cell *matCellDef="let element"> {{element.loaded_weight.toFixed(2) || '-'}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="capacity">
                        <th mat-header-cell *matHeaderCellDef> {{'Vehicle Capacity'| translate}} <br> {{'Minimum Wt. Guarantee'| translate}} <br> (MT) </th>
                        <td mat-cell *matCellDef="let element"> {{element.vehicle_capacity.toFixed(2) || '-'}}<br>
                            {{element.MWG|| '-'}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="mwga">
                        <th mat-header-cell *matHeaderCellDef> {{' MWG-A (MT)'}} </th>
                        <td mat-cell *matCellDef="let element"> {{element.MWGA.toFixed(2) || '-'}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="status">
                        <th mat-header-cell *matHeaderCellDef> {{'Status'| translate}} </th>
                        <td mat-cell *matCellDef="let element"> {{element.status || '-'}}
                        </td>
                    </ng-container>


                    <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky: true"></tr>
                    <tr mat-row *matRowDef="let row;let i=index; columns: displayedColumns;"
                        [ngClass]="{'highlightTableColor': selectedRowIndex == i}">
                    </tr>
                </table>
            </div>
            <mat-paginator fixed [length]="mwgDatasource ? totalMwgCount : 0" [pageSize]="10"
            [pageSizeOptions]="[200, 400, 500]" [showFirstLastButtons]="true" (page)="pageNavigate($event)">
          </mat-paginator>
        </div>
    </div>
</div>
<ng-template #showData>
    <div class="rowDataDialog">
        <div class="dialog_header">
            <div class="dialog_title">{{vehicleNumber}} / {{odNumber}}</div>
            <div class="dialog_close" (click)="showDialogRef.close()">
                <i class="material-icons">close</i>
            </div>
        </div>
        <div class="dialog_body">

            <ul *ngFor="let row of rowData">

                <li style="--accent-color:#002563">
                    <div class="icon"><i class="fa-brands fa-css3"></i></div>
                    <div class="title">{{'CLOSEDTRIPSDETAILS.source_location'| translate}}</div>
                    <div class="descr">{{ row.srcLoc || 'N/A'}}</div>
                </li>
                <li style="--accent-color:#002563">
                    <div class="icon"><i class="fa-brands fa-css3"></i></div>
                    <div class="title">{{'CLOSEDTRIPSDETAILS.destination'| translate}}</div>
                    <div class="descr">{{ row.destination || 'N/A'}}</div>
                </li>

                <li style="--accent-color:#002563">
                    <div class="icon"><i class="fa-brands fa-css3"></i></div>
                    <div class="title">{{'CLOSEDTRIPSDETAILS.entry_no'| translate}}</div>
                    <div class="descr">{{ row.entry_no || 'N/A'}}</div>
                </li>

            </ul>
        </div>
    </div>
</ng-template>

<ng-template #noData>
    <app-no-data></app-no-data>
</ng-template>
